import { useState, useEffect } from "react";
import { Card, Tabs, useMantineTheme } from "@mantine/core";
import GuesLeadProfile from "../../GuestLeadProfile";
import {
  MemberStatus,
  useGetClientGuestLeadLazyQuery,
  useGetSignedAgreementsLazyQuery,
} from "src/generated/graphql";
import { useParams } from "react-router";
import LeadOverview from "./LeadOverview";
import AttendanceTab from "../../AttendanceTab";
import TransactionHistory from "../../TransactionHistory";
import ClientLogs from "../../ClientDetail/clientLogs";
import ClientPayments from "../../ClientDetail/Payments";
import Account from "../../ClientDetail/Account";

export enum TabsName {
  OVERVIEW = "Overview",
  PROFILE = "Profile",
  ACCOUNT = "Account",
  PAYMENTS = "Payments",
  ATTENDANCE = "Attendance",
  CHANGE_LOGS = "Change Logs",
}

const LeadDetail = () => {
  const theme = useMantineTheme();
  let border = `solid ${theme.colors.secondary[2]}`;
  let bg = theme.colors.secondary[2];
  let color = theme.colors.secondaryTextColor[0];

  const { clientId } = useParams<{ clientId: string }>();
  const [currentTab, setCurrentTab] = useState<TabsName>(TabsName.OVERVIEW);

  const [getAgreements, { data: agreementData }] =
    useGetSignedAgreementsLazyQuery({
      variables: {
        clientId: clientId || "",
      },
      fetchPolicy: "no-cache",
    });

  useEffect(() => {
    getLead();
    getAgreements();
  }, []);

  const refetch = () => {
    getLead();
    getAgreements();
  };

  const [getLead, { data: leadData }] = useGetClientGuestLeadLazyQuery({
    variables: {
      id: clientId!,
    },
    fetchPolicy: "no-cache",
  });

  const updateTab = (tabName: TabsName) => {
    setCurrentTab(tabName);
  };

  return (
    <Card
      style={{
        border: `1px ${border}`,
        color,
        overflow: "visible",
      }}
      radius="md"
      w="100%"
      p={0}
      bg="transparent"
    >
      <Tabs
        defaultValue="Overview"
        styles={{
          tabsList: {
            borderBottom: `2px solid ${color}`,
            color,
            padding: "0 15px",
          },
          tab: {
            marginBottom: -2.5,
            fontWeight: 500,
            borderBottomWidth: 3,
          },
          panel: {
            padding: 15,
          },
        }}
        value={currentTab}
        onTabChange={updateTab}
      >
        <Tabs.List bg={bg}>
          {Object.values(TabsName).map((e) => (
            <Tabs.Tab key={e} value={e} c={color}>
              {e}
            </Tabs.Tab>
          ))}
        </Tabs.List>

        <Tabs.Panel value={TabsName.OVERVIEW}>
          <LeadOverview
            agreementData={agreementData?.signedAgreementMany || []}
            leadData={leadData?.clientOne}
            onTabChange={updateTab}
            onRefetch={refetch}
          />
        </Tabs.Panel>

        <Tabs.Panel value={TabsName.PROFILE}>
          <GuesLeadProfile
            fetchGuest={getLead}
            data={leadData}
            memberStatus={MemberStatus.Lead}
          />
        </Tabs.Panel>

        <Tabs.Panel value={TabsName.ACCOUNT}>
          {currentTab === TabsName.ACCOUNT && <Account />}
        </Tabs.Panel>

        <Tabs.Panel value={TabsName.PAYMENTS}>
          {currentTab === TabsName.PAYMENTS && <TransactionHistory />}
        </Tabs.Panel>

        <Tabs.Panel value={TabsName.PAYMENTS}>
          {currentTab === TabsName.PAYMENTS && <ClientPayments />}
        </Tabs.Panel>

        <Tabs.Panel value={TabsName.ATTENDANCE}>
          {currentTab === TabsName.ATTENDANCE && <AttendanceTab />}
        </Tabs.Panel>

        <Tabs.Panel value={TabsName.CHANGE_LOGS}>
          <ClientLogs clientId={clientId || ""} />
        </Tabs.Panel>
      </Tabs>
    </Card>
  );
};

export default LeadDetail;
